import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import AxiosController from "../../authentication/AxiosController";
import Loader from "../../loader/Loader";
import { Pagination } from "react-bootstrap";
import ProductsSlider from "../../home/ProductsSlider";

const ReferralMarketers = () => {
    const { slug, lang } = useParams();
    const token = localStorage.getItem("token");
    const Navigate = useNavigate();
    const [_] = useTranslation("global");

    const [productsData, handleProdutsData] = useState({});
    const [page, handlePage] = useState(1);
    const [loading, handleLoader] = useState(false);
    const [altName, handleAltName] = useState("");
 
    const get_category_products = (
        slug,
        lang,
        token,
        handleProdutsData,
        handleLoader,
        page,
        handleAltName,
        categoryId = 23
    ) => {
        AxiosController.get(`api/${slug}/${lang}/category-products/${categoryId}/${page}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => {
                handleProdutsData(res.data[0]);
                handleAltName(res.data[1]);
                handleLoader(false);
            })
            .catch((e) => {
                handleLoader(false);
            });
    };

    useEffect(() => {
        if (token) {
            handleLoader(true);
            get_category_products(
                slug,
                lang,
                token,
                handleProdutsData,
                handleLoader,
                page,
                handleAltName,
                23  
            );
        } else {
            Navigate(`/ar/auth/login`);
        }
    }, [slug, lang, token, page]);

    return (
        <>
            <div className="container">
                <div className="d-flex flex-column gap-4 position-relative">
                    <Loader active={loading} />

                    {productsData.data && productsData.data.length > 0 && (
                        <ProductsSlider
                            row={productsData.data}
                            altName={altName}
                        />
                    )}

                </div>
            </div>
        </>
    );
};

export default ReferralMarketers;
